import type { ClefQuestion } from '@/data/clefQuiz';

/**
 * Perguntas de apoio para a aula "Repetição, dinâmica e andamento".
 * Cada pergunta mostra um sinal no lugar da pauta e pede o seu significado.
 */
export const SIGN_QUESTIONS: ClefQuestion[] = [
  {
    id: 'sign-repeat',
    glyph: '‖:  …  :‖',
    glyphHint: 'Barras de repetição',
    question: 'O que as barras de repetição indicam?',
    options: [
      'Repetir o trecho que está entre elas',
      'Tocar cada vez mais forte',
      'Fazer silêncio por um compasso',
      'Subir uma oitava',
    ],
    answerIndex: 0,
    explanation:
      'Ao chegar na barra de repetição final, você volta ao ponto marcado pela barra inicial e toca o trecho outra vez.',
  },
  {
    id: 'sign-piano',
    glyph: 'p',
    glyphHint: 'Dinâmica',
    question: 'O que a letra “p” (piano) indica?',
    options: ['Tocar suave', 'Tocar bem forte', 'Tocar mais rápido', 'Repetir o compasso'],
    answerIndex: 0,
    explanation:
      'A dinâmica diz a força do som. “p” (piano) pede som suave; “f” (forte) pede som forte.',
  },
  {
    id: 'sign-forte',
    glyph: 'f',
    glyphHint: 'Dinâmica',
    question: 'O que a letra “f” (forte) indica?',
    options: ['Tocar forte', 'Tocar suave', 'Fazer pausa', 'Tocar devagar'],
    answerIndex: 0,
    explanation: '“f” (forte) é o oposto de “p”: pede que o trecho seja tocado com mais força.',
  },
  {
    id: 'sign-allegro',
    glyph: 'Allegro',
    glyphHint: 'Andamento',
    question: 'O que a palavra “Allegro” indica?',
    options: [
      'Um andamento rápido e animado',
      'Um andamento lento',
      'Que o trecho deve ser repetido',
      'Que se deve tocar em silêncio',
    ],
    answerIndex: 0,
    explanation:
      'As palavras de andamento indicam a velocidade. Allegro pede um andamento rápido e animado.',
  },
  {
    id: 'sign-bpm',
    glyph: '♩ = 80',
    glyphHint: 'Andamento (metrônomo)',
    question: 'O que significa a indicação “♩ = 80”?',
    options: [
      'Tocar 80 semínimas por minuto',
      'Tocar 80 notas no total',
      'Repetir 80 vezes',
      'Esperar 80 segundos antes de começar',
    ],
    answerIndex: 0,
    explanation:
      'É a marcação do metrônomo: cabem 80 semínimas em cada minuto, o que define a velocidade.',
  },
  {
    id: 'sign-rit',
    glyph: 'rit.',
    glyphHint: 'Andamento',
    question: 'O que a abreviação “rit.” (ritardando) pede?',
    options: [
      'Ir diminuindo a velocidade aos poucos',
      'Acelerar aos poucos',
      'Voltar e repetir o trecho',
      'Tocar cada vez mais forte',
    ],
    answerIndex: 0,
    explanation:
      '“rit.” (ritardando) manda desacelerar aos poucos, chegando mais devagar perto do fim do trecho.',
  },
];